<template>
  <panel
    :breadcrumbs="breadcrumbs"
    :title="reportTitle"
  >
    <v-card v-if="masterDealer">
      <v-alert
        type="info"
        color="green darken-2"
        :value="true"
        class="mb-4"
        outline
      >
        - MDs are eligible for Black Activation Incentives up to the maximum tiers of their respective hierarchy (not
        limited to 10 tiers for MD).
        <br>
        - There is a breakaway according to each AD`s network.
        <br>
        <br>
        Example:
        <br>
        - If an MD(A) got a new MD(B) below him/her, the group activation under B will not count as a group activation
        for A.
      </v-alert>
    </v-card>
    <v-card v-if="areaDealer">
      <v-alert
        type="info"
        color="green darken-2"
        :value="true"
        class="mb-4"
        outline
      >
        - ADs are eligible for Black Activation Incentives up to the maximum tiers of their respective hierarchy (not limited to 8 tiers for AD)
        <br>
        - There is a breakaway according to each AD`s network.
        <br>
        <br>
        Example:
        <br>
        - If an AD (A) got a new AD(B) below him/her, the group activation under B will not count as a group activation
        for A.
      </v-alert>
    </v-card>
    <v-card>
      <v-toolbar
        dense
        card
      >
        <v-menu
          v-model="menu"
          close-on-content-click
          transition="scale-transition"
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="monthOf"
            prepend-icon="event"
            readonly
          />
          <v-date-picker
            v-model="monthOf"
            :max="maxDate"
            :allowed-dates="allowedMonths"
            min="2025-04"
            type="month"
            year-icon="date_range"
          />
        </v-menu>
        <v-spacer />
      </v-toolbar>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="blackIncentive"
        :loading="loading"
        :search="search"
        hide-actions
        header-class="custom-header"
        class="px-1 pb-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              {{ props.item.black }}
            </td>
            <td class="text-xs-center">
              {{ props.item.total_activation_ai }}
            </td>
            <td class="text-xs-center">
              {{ props.item.total_activation }}
            </td>
            <td class="text-xs-center">
              {{ props.item.total_black_ai }}
            </td>
          </tr>
        </template>
        <template
          #footer
        >
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td class="text-xs-center primary white--text">
              {{ totalBlackActivation }}
            </td>
            <td class="text-xs-center primary white--text">
              {{ totalBlackAi }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </panel>
</template>

<script>
import { DateTime, Interval } from 'luxon'
import { createGetParams } from '@/rest'
import security from '@/security'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "Panel" */ '@/components/Panel'),
  },
  data () {
    return {
      headers: [
        {
          align: 'left',
          sortable: false,
          text: 'Black Plan',
          value: 'black',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Total Ai per activation (RM)',
          value: 'total_activation_ai',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Total Activation',
          value: 'total_activation',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Total Black Ai (RM)',
          value: 'total_black_ai',
        },
      ],
      blackIncentive: [],
      royaltyIncentive: [],
      prepaidIncentive: [],
      loading: false,
      maxDate: '',
      menu: false,
      monthOf: null,
      noDataText: "There's nothing to display.",
      noResultText: 'No data that fits that criteria.',
      search: '',
      self: null,
      title: this.reportTitle,
      totalBlackActivation: null,
      totalBlackAi: null,
    }
  },

  computed: {
    areaDealer: function () {
      return security.me.dealerRank() === 'Area Dealer'
    },
    masterDealer: function () {
      return security.me.dealerRank() === 'Master Dealer'
    },

    reportTitle () {
      const rank = security.me.dealerRank()
      let prefix = ''

      if (rank === 'Master Dealer') prefix = 'MD'
      else if (rank === 'Area Dealer') prefix = 'AD'
      else prefix = rank || ''

      return `${prefix} Black Activation Incentive`
    },
    breadcrumbs () {
      return [
        {
          text: 'Group Incentive',
          disabled: false,
          to: '/GroupIncentive',
        },
        {
          text: this.reportTitle,
          disabled: true,
        },
      ]
    },
  },

  watch: {
    monthOf: function (val) {
      this.getPerformance(val)
    },
  },
  mounted: function () {
    const now = DateTime.local().setZone('Asia/Kuala_Lumpur')
    this.maxDate = this.monthOf = now.toFormat('yyyy-LL')
  },
  methods: {
    allowedMonths: function (month) {
      const ym = month.split('-')
      const whatMonth = DateTime.local(Number(ym[0]), Number(ym[1])).setZone('Asia/Kuala_Lumpur')
      const fromDate = DateTime.local(2018, 1, 1).setZone('Asia/Kuala_Lumpur')
      const now = DateTime.local().setZone('Asia/Kuala_Lumpur')

      return Interval.fromDateTimes(fromDate, now).contains(whatMonth)
    },
    getPerformance (month) {
      this.loading = true
      const params = createGetParams({
        month: month,
      })
      this.loading = true
      this.blackIncentive = []
      this.royaltyIncentive = []
      this.prepaidIncentive = []
      this.$rest.get('getMdGroupPrepaidAI.php', params)
        .then(function (response) {
          this.self = response.data.self
          this.royaltyIncentive = response.data.royaltyIncentive
          this.prepaidIncentive = response.data.prepaidIncentive
          this.blackIncentive = response.data.blackIncentive
          this.totalBlackActivation = response.data.totalBlackActivation
          this.totalBlackAi = response.data.totalBlackAi
          this.loading = false
        }.bind(this)).catch(error => {
          this.noDataText = error.message
          this.loading = false
        })
    },
  },
}
</script>

    <style>
    .custom-header {
      background-color: #1976D2; /* Example blue background */
      color: white;
    }
    </style>
